import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getSurveySection } from "app/features/surveySlice";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { FormControlModel } from "types";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import isNil from "lodash/isNil";
import isEmpty from "lodash/isEmpty";
import ErrorMessage from "ui/atoms/ErrorMessage";

type Props = {
  formik: any;
  sectionId: number;
};

const Step3: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};
  const noValues = Object.values(formik.values).some((values: any) => isEmpty(values?.value));

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      disabled: true,
      label: "Sedes",
      name: "branch",
      questionData: questions[0],
      elementType: ElementType.Select,
    },
    {
      key: 1,
      formik,
      visible: true,
      disabled: true,
      name: "jobTitle",
      label: "Nivel de cargo actual",
      questionData: questions[1],
      elementType: ElementType.Select,
    },
    {
      key: 2,
      formik,
      visible: true,
      disabled: true,
      questionData: questions[2],
      name: "compensationCompany",
      label: "Caja de compensación",
      elementType: ElementType.Select,
    },
    {
      key: 3,
      formik,
      visible: true,
      disabled: true,
      label: "Pensiones",
      name: "jubilation",
      questionData: questions[3],
      elementType: ElementType.Select,
    },
    {
      key: 4,
      formik,
      visible: true,
      disabled: true,
      name: "layoff",
      label: "Cesantias",
      questionData: questions[4],
      elementType: ElementType.Select,
    },
    {
      key: 5,
      formik,
      name: "eps",
      label: "EPS",
      disabled: true,
      visible: true,
      questionData: questions[5],
      elementType: ElementType.Select,
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos de usted en la empresa
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
      {noValues && (
        <ErrorMessage>
          Uno o más campos no tienen información, informe a un administrador de Gestor para completar la información
          faltante
        </ErrorMessage>
      )}
    </div>
  );
};

export default Step3;
